import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookLeadFormId = (props: { pageId?: number; id?: number | string } = {}) =>
  useQuery<crmModels.IFacebookLeadForm>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_ID, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: `/v1/crm/facebook/lead-form/${props?.id || ''}`,
          query: {
            pageId: props.pageId
          }
        })
      );

      return res?.data?.data;
    },
    enabled: !!props?.pageId && !!props?.id
  });
